import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import { SecondaryPopupService } from '../../services/secondary-popup.service';

@Component({
  selector: 'app-secondary-popup',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './secondary-popup.component.html',
  styleUrls: ['./secondary-popup.component.scss']
})
export class SecondaryPopupComponent implements OnInit, OnDestroy {
  private readonly popupService = inject(SecondaryPopupService);
  data: any = null;
  private dataSub = new Subscription();

  ngOnInit(): void {
    this.dataSub = this.popupService.getPopupData().subscribe((data) => (this.data = data));
  }

  ngOnDestroy(): void {
    this.dataSub.unsubscribe();
  }

  hide(): void {
    this.popupService.popupHide();
  }
}
